import { createContext, useContext, useMemo, type ReactNode } from "react";

import { useAuth } from "../auth/AuthProvider";
import { ApiClient } from "./client";

const ApiContext = createContext<ApiClient | null>(null);

export function ApiProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const client = useMemo(() => new ApiClient(auth.headers), [auth]);
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const ctx = useContext(ApiContext);
  if (ctx === null) {
    throw new Error("useApi must be used inside <ApiProvider>");
  }
  return ctx;
}
